import React, { useState } from 'react';
import { useGetAllForOfferQuery } from '../Service/extendedOfferBoardingPlacesApi';
import {
  useDeleteOfferBoardingPlaceMutation,
  useUpdateOfferBoardingPlaceMutation,
} from '../Service/offerBoardingPlacesApi';
import OfferFeatureSection from '../../Shared/Components/OfferFeatureSection/OfferFeatureSection';
import AutomaticOfferBoardingPlaceDialog from './AutomaticOfferBoardingPlaceDialog';
import { SxProps } from '@mui/material';
import SaveBoardingPlacesAsTemplateDialog from '../../BoardingPlaceTemplates/Components/SaveBoardingPlacesAsTemplateDialog';
import SaveAsTemplateButton from '../../Shared/Components/SaveAsTemplateButton/SaveAsTemplateButton';
import BoardingPlaceTemplateSelectorWrapper from './BoardingPlaceTemplateSelectorWrapper';

const OfferBoardingPlacesSection = ({ offerId }: { offerId?: number | null }) => {
  const resolvedOfferId = offerId ?? 0;
  const { data, isLoading, isError, error, refetch } = useGetAllForOfferQuery(resolvedOfferId, {
    skip: !offerId,
  });
  const [deletePlace] = useDeleteOfferBoardingPlaceMutation();
  const [updatePlace] = useUpdateOfferBoardingPlaceMutation();

  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [editedRow, setEditedRow] = useState<Partial<any>>({});
  const [openSaveDialog, setOpenSaveDialog] = useState(false);

  const errorStatus = (error as any)?.status;
  const isNotFound = errorStatus === 404;
  const shouldShowError = isError && !isNotFound;
  const normalizedData = isNotFound ? [] : (data ?? []);
  const resolvedErrorMessage =
    (error as any)?.data?.message ||
    (typeof (error as any)?.data === 'string' ? (error as any).data : undefined) ||
    'Nie udało się pobrać miejsc wsiadania.';

  const columns = [
    {
      key: 'city',
      label: 'Miasto',
      editable: true,
      type: 'text',
      SxProps: { width: '150px' } as SxProps,
    },
    {
      key: 'stop',
      label: 'Przystanek',
      editable: true,
      type: 'text',
      style: { minWidth: 400 },
    },
    {
      key: 'time',
      label: 'Godzina',
      editable: true,
      type: 'time',
    },
    { key: 'price', label: 'Cena', editable: true, type: 'number' },
  ];

  const handleDelete = async (ids: number[]) => {
    await Promise.all(ids.map((id) => deletePlace(id)));
    refetch(); // odświeżenie danych po usunięciu
  };

  const handleInlineSave = async (updatedRow: any) => {
    await updatePlace({ id: updatedRow.id, data: updatedRow }).unwrap();
    setEditingRowId(null);
    setEditedRow({});
    refetch();
  };

  return (
    <>
      {!!offerId && normalizedData.length > 0 && (
        <SaveAsTemplateButton
          onClick={() => setOpenSaveDialog(true)}
          label="Zapisz miejsca jako szablon"
        />
      )}
      <OfferFeatureSection
        offerId={offerId ?? undefined}
        title="Miejsca wsiadania"
        addButtonLabel="Dodaj miejsce wsiadania"
        AddDialogComponent={AutomaticOfferBoardingPlaceDialog}
        addDialogProps={{ offerId: offerId ?? undefined }}
        columns={columns}
        data={normalizedData}
        isLoading={isLoading}
        isError={shouldShowError}
        errorMessage={shouldShowError ? resolvedErrorMessage : undefined}
        getRowId={(row) => row.id}
        onDeleteSelected={handleDelete}
        enableSelect
        refetchData={refetch}
        emptyMessage="Brak miejsc wsiadania dla tej oferty."
        onInlineSave={handleInlineSave}
        editingRowId={editingRowId}
        setEditingRowId={setEditingRowId}
        editedRow={editedRow}
        setEditedRow={setEditedRow}
        TemplateSelectorComponent={
          offerId ? <BoardingPlaceTemplateSelectorWrapper offerId={offerId} /> : undefined
        }
      />
      {!!offerId && normalizedData.length > 0 && (
        <SaveBoardingPlacesAsTemplateDialog
          open={openSaveDialog}
          onClose={() => setOpenSaveDialog(false)}
          data={normalizedData}
          onSuccess={() => {
            // optional: toast/refetch
          }}
        />
      )}
    </>
  );
};

export default OfferBoardingPlacesSection;
